// src/hooks/useYouTubeFeed.js
import { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';

const LS_KEY = 'yt_last_seen_id';

export function useYouTubeFeed() {
  const [data, setData] = useState({
    videos: [],
    shorts: [],
    playlists: [],
    latestVideoId: null,
    channelInfo: { avatar: '', name: 'Clube do Eu', subscribers: '0' },
  });
  const [showBadge, setShowBadge] = useState(false);

  useEffect(() => {
    let cancelled = false;

    async function fetchFeed() {
      const { data: result, error } = await supabase.functions.invoke('youtube-feed');
      if (cancelled || error || !result) return;
      setData(result);
      const lastSeen = localStorage.getItem(LS_KEY);
      if (result.latestVideoId && result.latestVideoId !== lastSeen) {
        setShowBadge(true);
      }
    }

    fetchFeed();
    return () => { cancelled = true; };
  }, []);

  function markAsSeen() {
    if (data.latestVideoId) {
      localStorage.setItem(LS_KEY, data.latestVideoId);
    }
    setShowBadge(false);
  }

  return { ...data, showBadge, markAsSeen };
}
